import React, { useState,  forwardRef,  useImperativeHandle } from "react";

const SimpleObjectRenderer = forwardRef((props, ref) => {
    const [val, setVal] = useState(props.value);
    useImperativeHandle(ref, () => {
        return {
            refresh(params) {
                var val = props.getValue();
                if (val != undefined) {
                    setVal(val);
                }
            }
        };
    });
    return (
        <span className="editableCell">{val && val.label ? val.label : <div><span className="addtext"></span><div className="addtextafter"><i className="fa fa-plus"></i></div></div>}</span>
    );
});

export default SimpleObjectRenderer;

